<template>
    <section class="textBanner py-12 lg:py-50 bg-gravaalightwarmgray text-gravaadarkbrown">
        <UiExtraNarrowContent>            
            <h3 v-html="article.content" class="text-center"></h3>
        </UiExtraNarrowContent>        
    </section>
</template>

<script setup lang="ts">

import { useBlogStore } from '@/stores/blogStore';
import { computed } from 'vue';

const blogStore = useBlogStore();

// Props
const props = defineProps({
    article: {
        type: Object,
        required: true
    }
});
</script>
